import { useParams } from "react-router-dom";
import ProjectleidersBoard from "../components/projectleiders/ProjectleidersBoard";

export default function ProjectleidersPage() {
  const { projectId } = useParams();
  return <ProjectleidersBoard projectId={projectId} />;
}
